<template>
  <v-dialog
    v-model="enableDialog"
    persistent
    :max-width="options.width"
  >
    <v-card>
      <v-toolbar
        v-if="!!title"
        :color="titleColor"
        dark
        dense
        flat
      >
        <v-toolbar-title class="white--text">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text
        v-show="!!message"
        class="pa-4"
        style="white-space:pre-wrap; word-wrap:break-word;"
      >
        {{ message }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="closeButtonClickEvent"
        >
          {{ options.cancelTitle }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SystemMessageDialogComponent',
  data () {
    return {
      dialog: false,
      options: {
        width: 350,
        cancelTitle: '閉じる',
        headingMessage: null,
      }
    }
  },
  computed: {
    ...mapState('systemMessageDialog', {
      enableDialog: 'show',
      title: 'title',
      message: 'message',
      titleColor: 'title_color',
    }),
  },
  watch: {
  },
  methods: {
    ...mapActions('systemMessageDialog', {
      hideDialog: 'hide'
    }),
    closeButtonClickEvent () {
      this.hideDialog()
    },
  }
}

</script>
